import type { ReactNode } from "react";

export type AlertTone = "failed" | "warning" | "info" | "done";

const NOTICE_STATE: Record<AlertTone, string> = {
  failed: "--alert",
  warning: "--warning",
  info: "--info",
  done: "--success",
};

/**
 * One box for everything that interrupts the reader — a failed extraction,
 * pages that could not be read, an upload that went through. An SDS notice;
 * the tone picks its visual state and built-in icon.
 *
 * `role="alert"` only on the failing tones: announcing a success banner
 * interrupts a screen reader mid-sentence for news that can wait.
 */
export function Alert({
  tone,
  title,
  children,
}: {
  tone: AlertTone;
  title?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={`ds-notice ${NOTICE_STATE[tone]}`}
      role={tone === "failed" ? "alert" : undefined}
    >
      {title !== undefined && <h3>{title}</h3>}
      <p>{children}</p>
    </div>
  );
}
